module.exports = __webpack_public_path__ + "img/4.4da6d8cf.png";